import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import {
  addSuggestionMessage,
  addToolCallMessage,
  updateLastMessage,
} from 'slices/aiConversations'
import type { PickerSubmissionPayload } from 'slices/aiConversations/pickerTypes'
import { submitPickerResponseThunk } from 'slices/aiConversations/thunks'

export function useAIConversationActions() {
  const dispatch = useDispatch()

  const onSuggestionClick = (suggestion: string) => {
    dispatch(addSuggestionMessage(suggestion))
  }

  const addToolCall = (content: string) => {
    dispatch(addToolCallMessage(content))
  }

  const updateMessage = (
    updates: Partial<{ content: string; isToolCall?: boolean }>
  ) => {
    dispatch(updateLastMessage(updates))
  }

  const onPickerSubmit = useCallback(
    (messageId: string, payload: PickerSubmissionPayload) => {
      // Send the picker response via WebSocket (not visible in UI)
      // This behaves like saveSegment - sends to backend without adding to Redux messages
      dispatch(submitPickerResponseThunk({ messageId, payload }))
    },
    [dispatch]
  )

  return {
    onSuggestionClick,
    addToolCall,
    updateMessage,
    onPickerSubmit,
  }
}
